const en = {
  ID_STUDIO_NEW_PROJECT_POPUP_TITLE: "Create New Project",
  ID_STUDIO_NEW_PROJECT_POPUP_SELECT_TECH_LANGUAGE: "Language",
  ID_STUDIO_NEW_PROJECT_POPUP_TEXT_CODING: "Text",
  ID_STUDIO_NEW_PROJECT_POPUP_BLOCK_CODING: "Block",

  ID_STUDIO_NEW_PROJECT_POPUP_PROJECT_NAME: "프로젝트 명",
  ID_STUDIO_NEW_PROJECT_POPUP_PROJECT_NAME_INPUT_PLACEHOLDER: "프로젝트명을 입력해주세요.",

  ID_STUDIO_NEW_PROJECT_POPUP_STAR_BTN: "Start",

  ID_STUDIO_LIST_TITLE: "Studio",
  ID_STUDIO_CREATE_LIST_TITLE: "Create New Project",
  ID_STUDIO_CREATE_WORLD_BTN: "3D World",
  ID_STUDIO_MY_PROJECT_TITLE: "My Project",
  ID_STUDIO_PUBLISHED_APP_TITLE: "Publishing Content",

  ID_STUDIO_OOBC_LABEL: "OOBC",
  ID_STUDIO_JS_LABEL: "JS",

  ID_STUDIO_LIST_MORE_VIEW: "See All",
  ID_STUDIO_LIST_PUBLIC: "Public",
  ID_STUDIO_LIST_DROP_EDIT: "Edit",
  ID_STUDIO_LIST_DROP_DELETE: "Delete",
  ID_STUDIO_LIST_DROP_COPY: "Copy",

  ID_SUTDIO_EDIT_CONTENT_TITLE: "Edit Content",
  ID_STUDIO_EDIT_CONTENT_CATEGORY_NAME: "Content Name",
  ID_STUDIO_EDIT_CONTENT_CATEGORY_EXPLAIN: "Content Description",
  ID_STUDIO_EDIT_IMAGE_NOTICE_TEXT: "*If you don't register the representative image,\nit will be automatically registered.",
  ID_STUDIO_EDIT_CHANGE_IMAGE_BUTTON: "Change Iamge",
  ID_STUDIO_EDIT_CANCEL_BUTTON: "Cancel",
  ID_STUDIO_EDIT_CONTENT_NAME_PLACEHOLDER: "Please enter a content name.",
  ID_STUDIO_EDIT_CONTENT_TEXTAREA_PLACEHOLDER: "Please enter a description for the content",

  ID_STUDIO_PROJECT_DELETE_CONFIRM_MESSAGE: "Would you like to delete the project?",
  ID_STUDIO_PUBLISHED_DELETE_CONFIRM_MESSAGE: "Would you like to delete the publishing content?",

  // Tooltip
  ID_STUDIO_TOOLTIP_UNDO_BTN_DESC: "Undo",
  ID_STUDIO_TOOLTIP_UNDO_BTN_SHORTCUT: "Ctrl + Z",
  ID_STUDIO_TOOLTIP_REDO_BTN_DESC: "Redo",
  ID_STUDIO_TOOLTIP_REDO_BTN_SHORTCUT: "Ctrl + Shift + Z",
  ID_STUDIO_TOOLTIP_POSITION_BTN_DESC: "Position",
  ID_STUDIO_TOOLTIP_POSITION_BTN_SHORTCUT: "2",
  ID_STUDIO_TOOLTIP_ROTATION_BTN_DESC: "Rotation",
  ID_STUDIO_TOOLTIP_ROTATION_BTN_SHORTCUT: "3",
  ID_STUDIO_TOOLTIP_SCALE_BTN_DESC: "Scale",
  ID_STUDIO_TOOLTIP_SCALE_BTN_SHORTCUT: "4",
  ID_STUDIO_TOOLTIP_OBJECT_PANEL_OPEN: "Open Panel",
  ID_STUDIO_TOOLTIP_OBJECT_PANEL_CLOSE: "Fold Panel",
  ID_STUDIO_TOOLTIP_PROPERTY_PANEL_OPEN: "Open Panel",
  ID_STUDIO_TOOLTIP_PROPERTY_PANEL_CLOSE: "Fold Panel",
  ID_STUDIO_TOOLTIP_PLAY_BTN: "Play",
  ID_STUDIO_TOOLTIP_STOP_BTN: "Stop",
  ID_STUDIO_TOOLTIP_CODE_MODE_BTN: "Code Mode",
  ID_STUDIO_TOOLTIP_DELETE_BTN: "Delete",
};

export default en;
